import api from "../api.client";
import {
  AdminCourseResponse,
  CourseDto,
  CourseAdmin,
} from "@/shared/types/Course";

const BASE_URL = "/admin/courses";

function buildCourseFormData(payload: CourseDto): FormData {
  const fd = new FormData();

  fd.append("Title", payload.title ?? "");
  fd.append("Description", payload.description ?? "");
  fd.append("CourseLevel", String(payload.courseLevel ?? ""));
  fd.append("Status", String(payload.status ?? ""));

  if (payload.imageFile) {
    fd.append("Image", payload.imageFile);
  }

  fd.append("CourseAccessRules", JSON.stringify(payload.courseAccessRules ?? []));
  if (payload.courseIdPrerequisites && payload.courseIdPrerequisites.length > 0) {
    payload.courseIdPrerequisites.forEach((id) => {
      fd.append("CourseIdPrerequisites", String(id));
    });
  }

  return fd;
}

const CoursesAdminService = {
  getCoursesPaginated: async (
    page: number,
    pageSize: number,
    search: string = "",
    signal?: AbortSignal
  ): Promise<AdminCourseResponse> => {
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("pageSize", String(pageSize));
    if (search) params.append("search", search);

    const url = `${BASE_URL}?${params.toString()}`;
    return api.get<AdminCourseResponse>(url, { signal });
  },

  getCourseById: async (
    courseId: number,
    signal?: AbortSignal
  ): Promise<CourseAdmin> => {
    return api.get<CourseAdmin>(`${BASE_URL}/${courseId}`, { signal });
  },

  CreateCourse: async (payload: CourseDto): Promise<CourseAdmin> => {
    const fd = buildCourseFormData(payload);
    return api.post<CourseAdmin>(BASE_URL, fd);
  },

  updateCourse: async (
    payload: CourseDto,
    courseId: number
  ): Promise<CourseAdmin> => {
    const fd = buildCourseFormData(payload);
    return api.patch<CourseAdmin>(`${BASE_URL}/${courseId}`, fd);
  },

  deleteCourse: async (courseId: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${courseId}`);
  },

  getCourseImageUrls: async (
    courseIds: number[],
    expiryMinutes: number = 60
  ): Promise<Record<number, string>> => {
    return api.post<Record<number, string>>(`${BASE_URL}/image-urls`, {
      courseIds,
      expiryMinutes,
    });
  },
};

export default CoursesAdminService;
